module.exports = __webpack_public_path__ + "img/c15.561c4980.png";